<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryForm" :label-position="labelPosition" label-width="100px" class="searchForm">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item :label="$t('taskList.taskFlow')" prop="taskType">
                <ic-select :clearable="true" v-model="queryCondition.taskType" :options="{
                                LINE_SOURCING:'按线路报价价格确认流程',
								QUOTATION:'供应商报价',
								PRODUCT_SOURCING:'按产品报价价格确认流程',
								STORE_FEEDBACK:'质量反馈',
								PROBLEM_REPORT_HANDLE:'问题报告处理',
								MSV:'MSV审核',
                                SUPPLIER_REG:'潜在供应商',
                                SUPPLIER_REG_MDM:'潜在供应商MDM',
								SUPPLIER_UPDATE:'供应商资源管理',
								FPA_PERMANENT:'FPA_PERMANENT',
								FPA_LTO_CAMPAIGN:'FPA_LTO_CAMPAIGN',
								FPA_LTO:'FPA_LTO',
                                BC:'BC',
								GRI:'GRI',
                                CAPACITY:'产能调查',
								UNIT_OF_ACCOUNT:'结算单位',
								LAW_FILE:'法务文件',
                                MATERIAL:'物料审核',
								DC:'DC审核',
                                }"></ic-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('taskList.bizNo')" prop="bizNo">
                <el-input class="handle-input" v-model.trim="queryCondition['bizNo']" clearable style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="创建日期(从)" prop="dateFrom">
                <el-date-picker style="width: 100%" v-model="queryCondition.dateFrom" type="date" :picker-options="pickerOptionsStart" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="创建日期(至)" prop="dateTo">
                <el-date-picker style="width: 100%" value-format="yyyy-MM-dd" v-model="queryCondition.dateTo" :picker-options="pickerOptionsEnd" type="date" :placeholder="$t('common.selDate')"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="center">
            <el-button size="mini" class="btn" type="primary" @click="queryData(1)">{{$t('common.search')}}</el-button>
            <el-button size="mini" type="primary" @click="resetForm()">{{$t('common.reset')}}</el-button>
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <el-button v-acl="TaskListTransfer" type="primary" @click="openTransferDialog">转移任务</el-button>
      </el-row>
      <el-table :data="tableData" border max-height='530' @selection-change="changeSelect" highlight-current-row>
        <el-table-column type="selection" :selectable="(row)=>row.status != 'FINISH'" width="55" align="center"></el-table-column>
        <el-table-column show-overflow-tooltip prop="taskTypeName" :label="$t('taskList.taskFlow')"></el-table-column>
        <el-table-column show-overflow-tooltip prop="bizNo" :label="$t('taskList.bizNo')" min-width="140">
          <template slot-scope="scope">
            <el-link class="el-link" @click="view(scope.row.taskType,scope.row.bizId,scope.row)">{{scope.row.bizNo}}</el-link>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="createDate" :label="$t('common.TaskCreationTime')"><template slot-scope="scope">{{scope.row.createDate|dateFormatFilter("YYYY-MM-DD HH:mm:ss")}}</template></el-table-column>
        <el-table-column show-overflow-tooltip prop="status" :label="$t('common.status')"></el-table-column>
        <el-table-column :label="$t('common.operation')">
          <template slot-scope="scope">
            <el-button v-acl="MyTaskImg" @click="changeImg(scope.row.piId)" type="primary">img</el-button>
            <el-button v-acl="finish_task" v-if="scope.row.status != 'FINISH'" @click="delTask(scope.row.piId,scope.row)" type="primary">结束工作流</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination :page-sizes="[10,15,50,100]" @size-change="pageSizeChange" :page-size="queryCondition.pageSize" :current-page="queryCondition.pageNum" @current-change="pageNumberChange" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
      </div>
    </div>
    <el-dialog title="流程进度" :visible="imgDialog" @close="imgDialog = false" width="600px" class="dialog">
      <img :src="src">
    </el-dialog>
    <el-dialog :visible="auditDialog" @close="auditDialog = false" width="1200px" class="dialog">
      <router-view></router-view>
    </el-dialog>
    <el-dialog title="任务转移" :visible="transferDialog" width="600px" class="dialog" @close="transferDialog = false">
      <el-form :model="transferForm" :rules="transferFormRules" ref="transferForm" label-width="100px">
        <el-form-item label="转移到" prop="transferToUserIds">
          <pickupUser v-if="hackReset" ref="pickupUser" multi title="选择人员" @change="changeTransferTo"></pickupUser>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="transfer()">确定</el-button>
          <el-button type="primary" @click="transferDialog=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import taskApi from "../../../api/myTask";
import { Message } from "element-ui";
import pickupUser from "@/components/common/pickupUser"
import dataTableFuns from "@/utils/dataTableUtils";
import utils from "@/utils/commonFun";
import IcSelect from "@/components/common/icSelect";
import DateRanger from "@/components/common/dateRanger";

export default {
  name: 'task-list',
  components: {
    DateRanger,
    IcSelect,
    pickupUser,
  },
  data() {
    var noEmpty = (rule, value, callback) => {
      console.log(this.transferForm.transferToUserIds)
      if (this.transferForm.transferToUserIds == null || this.transferForm.transferToUserIds == '')
        callback("请选择人员");
      else {
        callback();
      }
    };
    return {
      tableData: [],
      selectedData: [],
      total: 0,
      labelPosition: 'right',
      queryCondition: {
        taskName: '',
        taskTypeName: '',
        pageNum: 1,
        pageSize: 15,
        createDateArr: '',
        dateFrom: '',
        dateTo: '',
        taskType: '',
        bizNo: ''
      },
      dateRange: [],
      hackSet: false,
      transferForm: {
        transferToUserIds: null,
        transferToUsers: null
      },
      transferFormRules: {
        transferToUserIds: [
          { required: true, trigger: "change", validator: noEmpty }
        ]
      },
      transferDialog: false,
      imgDialog: false,
      auditDialog: false,
      authSearch: '',
      routeObj: {
        key: 'routeNodeId',
        label: 'routeNodeName'
      },
      src: '',
      hackReset: true,
      // pickerOptionsStart: {
      //   // 开始时间小于结束时间
      //   disabledDate: time => {
      //     let endTime = this.queryCondition.dateTo;
      //     if (endTime) {
      //       return time.getTime() > new Date(endTime).getTime();
      //     }
      //   }
      // },
      // pickerOptionsEnd: {
      //   disabledDate: time => {
      //     let beginTime = this.queryCondition.dateFrom;
      //     if (beginTime) {
      //       return time.getTime() < new Date(beginTime).getTime() - 24 * 60 * 60 * 1000;
      //     }
      //   }
      // },
    }
  },
  created() {
    // this.queryData(1);
  },
  mounted() {
    if (this.$route.meta.auditDialog) {
      this.auditDialog = true;
    } else {
      this.auditDialog = false;
    }
  },
  methods: {
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      if (this.dateRange.length > 0) {
        this.queryCondition.dateFrom = this.dateRange[0]
        this.queryCondition.dateTo = this.dateRange[1]
      }
      taskApi.taskList(this.queryCondition).then((res) => {
        this.tableData = res.data.records;
        this.total = res.data.total;
      });
    },
    changeImg(piId) {
      taskApi.getImg(piId)
        .then(response => {
          return new Buffer(response, 'binary').toString('base64');
        })
        .then(data => {
          this.src = "data:image/png;base64," + data;
          this.imgDialog = true;
        });
    },
    changeTransferTo(userList) {
      this.transferForm.transferToUserIds = userList.map(value => value.tmUserId);
      this.$refs["transferForm"].validate((valid) => { })
    },
    openTransferDialog() {
      let that = this
      if (utils.isEmpty(this.selectedData)) {
        Message.error("请选择需要转移的工作流");
      } else {
        that.hackReset = false
        that.$nextTick(() => {
          that.hackReset = true
        })
        this.transferDialog = true;
        this.transferForm.transferToUsers = [];
      }
    },
    changeSelect(val) {
      this.selectedData = val;
    },
    resetForm() {
      this.$refs['queryForm'].resetFields();
      this.dateRange = []
      this.queryCondition.dateFrom = ''
      this.queryCondition.dateTo = ''
      this.queryCondition.pageSize = 15;
      this.queryCondition.pageNum = 1;
      this.queryData();
    },
    delTask(piId, row) {
      let that = this
      // let no = row.bizNo
      that.$confirm(that.$t('taskList.sureEnd'), that.$t('common.message'), {
        confirmButtonText: that.$t('common.confirm'),
        cancelButtonText: that.$t('common.cancel'),
        customClass: 'colorBtn',
        type: 'warning'
      }).then(() => {
        taskApi.delTask(piId).then(data => this.queryData())
      });

    },
    view(taskType, bizId, row) {
      var that = this;
      console.log(row)
      let taskName = row.taskName
      switch (taskType) {
        case "MSV":
          this.$router.push({
            path: `/visitReport-add`,
            query: { ttMsvReportId: bizId }
          });
          break;
        case "SENSORY_REPORT":
          this.$router.push({
            path: `/sensoryTemplate-add`,
            query: { ttSensoryTemplateId: bizId, taskApproval: true },
          });
          break;
        case "LINE_SOURCING":
        case "PRODUCT_SOURCING":
          this.$router.push({ name: "auditSourcing", query: { sourcingId: bizId } });
          that.detailDialog = true;
          break;
        case "PROBLEM_REPORT_HANDLE":
          that.$router.push({ name: "feedbackReportView", query: { action: 'audit', feedbackReportId: bizId } });
          break;
        case "STORE_FEEDBACK":
          this.$router.push({
            path: `/storeFeedback-detail`,
            query: {
              feedbackId: bizId
            }
          });
          break;
        case "CAPACITY":
          this.$router.push({
            path: `/capacityDetail`,
            query: { ttCapacityId: bizId },
          });
          break;
      }
    },
    transfer() {
      let that = this;
      this.$refs["transferForm"].validate((valid) => {
        if (valid) {
          let taskIds = this.selectedData.map(value => value.taskId);
          let to = this.transferForm.transferToUserIds;
          let param = {
            taskIds: taskIds,
            toUserId: to
          };
          taskApi.transfer(param).then(resp => {
            this.queryData();
            this.$refs.pickupUser.init();
            this.transferDialog = false;
          })
        } else {
          return false;
        }
      })
    }
  },
  extends: dataTableFuns
}
</script>
<style scoped>
.handle-input {
  width: 95%;
}

.dialog-input {
  width: 85%;
}

.dialog >>> .el-dialog__body {
  max-height: 450px;
  overflow: auto;
}
.taskList .el-date-editor--daterange.el-input__inner {
  width: auto;
}
.taskList .el-link {
  text-decoration: underline;
  color: #f8ab01 !important;
  cursor: pointer;
  font-size: 12px;
}
</style>
<style scoped>
.colorBtn .el-button {
  background: #f8ab01 !important;
  color: #fff !important;
  border-color: #f8ab01 !important;
}
.el-select {
  width: 100%;
}
</style>


